import { useGetReportDetailsQuery } from 'gqlTypes'
import { useMemo } from 'react'

const useReportDetails = (reportId: string) => {
  const { data, loading } = useGetReportDetailsQuery({
    variables: { id: reportId },
  })

  const report = data?.report

  const parsedData = useMemo(
    () => (report?.data ? JSON.parse(report?.data) : {}),
    [report]
  )

  const hiddenSubgroupOptions: { name: string; values: string[] }[] = []
  report?.subgroups.forEach((subgroup: string) => {
    const segItems: string[] = []
    Object.keys(parsedData.elements).forEach((d: any) => {
      const segmentations = parsedData.elements[d].segmentations
      if (segmentations && segmentations.length) {
        const series = segmentations
          .filter((s: any) => s.name === subgroup && (s.values || s.series))
          .map((s: any) => (s.values || s.series).map((s2: any) => s2.name))
          .flat()
        series.forEach((s: string) => {
          if (segItems.indexOf(s) === -1) {
            segItems.push(s)
          }
        })
      }
    })
    hiddenSubgroupOptions.push({ name: subgroup, values: segItems })
  })

  return useMemo(
    () => ({
      cohorts: report?.cohorts || [],
      subgroups: report?.subgroups || [],
      data: report?.data || {},
      parsedData,
      parsedDataLoading: loading,
      title: report?.title,
      schoolName: report?.schoolName || '',
      surveyType: report?.surveyType || '',
      hiddenSubgroupOptions: hiddenSubgroupOptions,
      report,
    }),
    [report]
  )
}

export default useReportDetails
